import { CSSProperties } from 'react';
import { MotionStyle } from 'framer-motion';

export const containerStyle: MotionStyle = {
  width: '100%',
  height: '70px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  marginBottom: '2px'
};

export const iconBackgroundStyle: CSSProperties = {
  width: '72px',
  height: '72px',
  marginLeft: '5px',
  borderRadius: '50px',
  background: '#F85A89',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

export const iconContainerStyle: CSSProperties = {
  width: '100px',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

export const buttonContainerStyle = (hasLikes: boolean): CSSProperties => ({
  width: '40px',
  display: 'flex',
  alignItems: 'center',
  opacity: hasLikes ? 1 : 0
});

export const textStyle: CSSProperties = {};

export const textContainerStyle: CSSProperties = {
  width: 'calc(100% - 140px)',
  height: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center'
};
